module.exports = __webpack_public_path__ + "08_bob_gold.04a76408.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/08_bob_gold.png
// module id = n2z2
// module chunks = 0